export const CREATE_EDIT_ROUTE_MODAL = 'create-edit-route';
export const DELETE_ROUTE_MODAL = 'delete-route';
export const MANAGE_USER_ROUTES_MODAL = 'manage-user-routes';
export const BUS_STOP_DRAWER = 'bus-stop-drawer';
export const TRANSPORTATION_REQUEST = 'transportation-request';
export const TRANSPORTATION_REQUEST_DENY = 'transportation-request-deny';
export const TRANSPORTATION_EDIT_REQUEST = 'transportation-edit-request';
